import React, { useState, useEffect } from 'react';

const ContactPage = ({ setActiveTab }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    inquiryType: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('¡Gracias por tu mensaje! Te contactaremos pronto.');
  };

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>Contáctanos</h1>
        <p>Estamos aquí para ayudarte con todas tus necesidades inmobiliarias</p>
      </div>

      {/* AI Assistant Highlight
      <div className="ai-contact-highlight">
        <div className="ai-highlight-card">
          <h2>🤖 ¿Necesitas ayuda inmediata?</h2>
          <p>
            Nuestro asistente IA está disponible 24/7 para responder tus preguntas 
            sobre propiedades, precios, ubicaciones y más.
          </p>
          <button 
            className="button-primary"
            onClick={() => setActiveTab('chatbot')}
          >
            Hablar con Asistente IA
          </button>
        </div>
      </div> */}

      {/* Contact Form */}
      <div className="contact-form-section">
        <h2>Envíanos un Mensaje</h2>
        <form
          action="https://formspree.io/f/meovonqz"
          method="POST"
          className="contact-form"
        >
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Nombre Completo</label>
              <input
                type="text"
                id="name"
                name="name"
                required
                className="form-input"
                placeholder="Tu nombre completo"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Correo Electrónico</label>
              <input
                type="email"
                id="email"
                name="email"
                required
                className="form-input"
                placeholder="tu@email.com"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="phone">Teléfono</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                className="form-input"
                placeholder="+506 1234-5678"
              />
            </div>

            <div className="form-group">
              <label htmlFor="inquiryType">Tipo de Consulta</label>
              <select
                id="inquiryType"
                name="inquiryType"
                className="form-select"
              >
                <option value="">Seleccionar tipo</option>
                <option value="buying">Quiero comprar</option>
                <option value="selling">Quiero vender</option>
                <option value="valuation">Valuación de propiedad</option>
                <option value="investment">Inversión inmobiliaria</option>
                <option value="general">Consulta general</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="message">Mensaje</label>
            <textarea
              id="message"
              name="message"
              required
              className="form-textarea"
              rows="5"
              placeholder="Cuéntanos cómo podemos ayudarte..."
            ></textarea>
          </div>

          <button type="submit" className="button-primary form-submit">
            Enviar Mensaje
          </button>
        </form>
      </div>


      {/* Contact Information */}
      <div className="contact-info-section">
        <h2>Información de Contacto</h2>
        <div className="contact-info-grid">
          <div className="contact-info-card">
            <div className="contact-icon">📧</div>
            <h3>Email</h3>
            <p>info@linkcapitalsolutions.com</p>
            <p>vinicio@linkcapitalsolutions.com</p>
          </div>

          <div className="contact-info-card">
            <div className="contact-icon">📞</div>
            <h3>Teléfono</h3>
            <p>WhatsApp: +506 6082-1024</p>
          </div>

          <div className="contact-info-card">
            <div className="contact-icon">📍</div>
            <h3>Oficina</h3>
            <p>San José, Costa Rica</p>
            <p>Escazú Village Torre 2 Piso 2</p>
          </div>

          <div className="contact-info-card">
            <div className="contact-icon">🕒</div>
            <h3>Horarios</h3>
            <p>Lun - Vie: 8:00 AM - 6:00 PM</p>
            <p>Sáb: 9:00 AM - 2:00 PM</p>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="faq-section">
        <h2>Preguntas Frecuentes</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h3>¿Cómo funciona el asistente IA?</h3>
            <p>
              Simplemente describe lo que buscas en lenguaje natural. Nuestro asistente 
              entiende tus necesidades y busca propiedades que coincidan perfectamente.
            </p>
          </div>

          <div className="faq-item">
            <h3>¿Hay costo por usar la plataforma?</h3>
            <p>
              El uso del asistente IA y la búsqueda de propiedades es completamente gratuito. 
              Solo cobramos comisión cuando se completa una transacción.
            </p>
          </div>

          <div className="faq-item">
            <h3>¿En qué zonas de Costa Rica operan?</h3>
            <p>
              Cubrimos todo el territorio nacional, con especial enfoque en el Gran Área 
              Metropolitana, Guanacaste, y las principales zonas turísticas.
            </p>
          </div>

          <div className="faq-item">
            <h3>¿Qué tan precisa es la valuación IA?</h3>
            <p>
              Nuestro sistema analiza miles de transacciones recientes y factores del mercado 
              para ofrecer valuaciones comparables a un avaluo.
            </p>
          </div>
        </div>
      </div>

      {/* Social Media */}
      <div className="social-section">
        <h2>Síguenos en Redes Sociales</h2>
        <div className="social-links">
          <a href="#" className="social-link facebook">
            📘 Facebook
          </a>
          <a href="#" className="social-link instagram">
            📷 Instagram
          </a>
          <a href="#" className="social-link linkedin">
            💼 LinkedIn
          </a>
          <a href="#" className="social-link youtube">
            📺 YouTube
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
